<template>
    <nav class="sip-mobile-bottom-nav d-md-none" aria-label="School Admin Mobile Navigation">
        <div class="sip-mobile-bottom-nav__inner">
            <!-- 1. Dashboard -->
            <router-link
                to="/home"
                class="sip-mobile-nav-item"
                :class="{ 'is-active': isDashboardActive }"
                aria-label="Dashboard"
            >
                <div class="sip-mobile-nav-item__icon-wrap">
                    <admin-icon name="home" :size="20"></admin-icon>
                </div>
                <span class="sip-mobile-nav-item__label">{{ trans('general.dashboard') || 'Dashboard' }}</span>
            </router-link>

            <!-- 2. Students -->
            <router-link
                to="/student/admission"
                class="sip-mobile-nav-item"
                :class="{ 'is-active': isStudentsActive }"
                aria-label="Students"
            >
                <div class="sip-mobile-nav-item__icon-wrap">
                    <admin-icon name="users" :size="20"></admin-icon>
                </div>
                <span class="sip-mobile-nav-item__label">{{ trans('student.student') || 'Students' }}</span>
            </router-link>

            <!-- 3. Employees / Staff -->
            <router-link
                to="/employee"
                class="sip-mobile-nav-item"
                :class="{ 'is-active': isEmployeesActive }"
                aria-label="Employees"
            >
                <div class="sip-mobile-nav-item__icon-wrap">
                    <admin-icon name="user" :size="20"></admin-icon>
                </div>
                <span class="sip-mobile-nav-item__label">{{ trans('employee.employee') || 'Staff' }}</span>
            </router-link>

            <!-- 4. Attendance / Academic -->
            <router-link
                to="/academic"
                class="sip-mobile-nav-item"
                :class="{ 'is-active': isAcademicActive }"
                aria-label="Academic"
            >
                <div class="sip-mobile-nav-item__icon-wrap">
                    <admin-icon name="book" :size="20"></admin-icon>
                </div>
                <span class="sip-mobile-nav-item__label">{{ trans('academic.academic') || 'Academic' }}</span>
            </router-link>

            <!-- 5. Navigation Menu / Drawer Toggle -->
            <button
                type="button"
                class="sip-mobile-nav-item sip-mobile-nav-item--btn"
                :class="{ 'is-active': isSidebarActive }"
                @click="toggleSidebar"
                aria-label="Toggle navigation menu"
            >
                <div class="sip-mobile-nav-item__icon-wrap">
                    <admin-icon name="menu" :size="20"></admin-icon>
                </div>
                <span class="sip-mobile-nav-item__label">{{ trans('general.menu') || 'Menu' }}</span>
            </button>
        </div>
    </nav>
</template>

<script>
export default {
    name: 'MobileBottomNav',
    data() {
        return {
            isSidebarActive: false
        };
    },
    mounted() {
        this.syncSidebarState();
        window.addEventListener('sip-sidebar-closed', () => {
            this.isSidebarActive = false;
        });
        window.addEventListener('sip-sidebar-opened', () => {
            this.isSidebarActive = true;
        });
        $(document).on('click', '#OpenMenuSideBar, #HideRightSideBarMenu, .nk-sidebar-overlay', () => {
            this.$nextTick(() => this.syncSidebarState());
        });
        const sidebar = document.getElementById('MainSideBarRightMenu');
        if (sidebar && typeof MutationObserver !== 'undefined') {
            this._sidebarObserver = new MutationObserver(() => {
                this.syncSidebarState();
            });
            this._sidebarObserver.observe(sidebar, { attributes: true, attributeFilter: ['class'] });
        }
    },
    beforeUnmount() {
        if (this._sidebarObserver) {
            this._sidebarObserver.disconnect();
        }
    },
    computed: {
        currentPath() {
            return this.$route ? this.$route.path : '';
        },
        isDashboardActive() {
            return this.currentPath === '/home' || this.currentPath === '/dashboard' || this.currentPath === '/';
        },
        isStudentsActive() {
            return this.currentPath.startsWith('/student') || this.currentPath.startsWith('/registration');
        },
        isEmployeesActive() {
            return this.currentPath.startsWith('/employee');
        },
        isAcademicActive() {
            return this.currentPath.startsWith('/academic') ||
                this.currentPath.startsWith('/timetable') ||
                this.currentPath.startsWith('/subject') ||
                this.currentPath.startsWith('/class-teacher') ||
                this.currentPath.startsWith('/attendance');
        }
    },
    watch: {
        $route() {
            this.closeSidebar();
        }
    },
    methods: {
        syncSidebarState() {
            const sidebar = document.getElementById('MainSideBarRightMenu');
            this.isSidebarActive = sidebar ? sidebar.classList.contains('nk-sidebar-active') : false;
        },
        toggleSidebar() {
            const sidebar = document.getElementById('MainSideBarRightMenu');
            if (sidebar) {
                sidebar.classList.toggle('nk-sidebar-active');
                this.isSidebarActive = sidebar.classList.contains('nk-sidebar-active');
                if (this.isSidebarActive) {
                    document.body.classList.add('nav-shown', 'sip-mobile-sidebar-open');
                    window.dispatchEvent(new CustomEvent('sip-sidebar-opened'));
                } else {
                    document.body.classList.remove('nav-shown', 'sip-mobile-sidebar-open');
                    window.dispatchEvent(new CustomEvent('sip-sidebar-closed'));
                }
            }
        },
        closeSidebar() {
            const sidebar = document.getElementById('MainSideBarRightMenu');
            if (sidebar && sidebar.classList.contains('nk-sidebar-active')) {
                sidebar.classList.remove('nk-sidebar-active');
                this.isSidebarActive = false;
                document.body.classList.remove('nav-shown', 'sip-mobile-sidebar-open');
                window.dispatchEvent(new CustomEvent('sip-sidebar-closed'));
            }
        }
    }
};
</script>
